import { API } from "./api";

export const processVideo = async (data, config = {}) =>
  API.post("/process-video", data, { ...config });

export const getVideoWithVideoId = async (data, config = {}) =>
  API.get(`/process-video/public/${data?.clientId}?videoId=${data?.videoId}`, {
    ...config,
  });

export const getAudioStream = async (data, config = {}) =>
  API.post("/audios", data, { ...config });

export const speechToText = async (data, config = {}) =>
  API.post("/audios/speech-to-text", data, { ...config });
